import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_COLLABORATEUR_SCHEMA_LITERAL = {
    title: 'Schéma collaborateurs',
    description: 'Décrit les collaborateurs',
    version: 1,
    keyCompression: false,
    primaryKey: 'CO_NO_STR',
    type: 'object',
    properties: {
        CO_NO_STR: { type: 'string', maxLength : 10 },
        CO_NO: { type: 'number' },
        CO_NOM: { type: ['string', 'null'] },
        CO_PRENOM: { type: ['string', 'null'] },
        CO_LIB: { type: ['string', 'null'] },
        CO_FONCTION: { type: ['string', 'null'] },
        CO_DOMAINE: { type: 'number' }
    },
    required: [ 'CO_NO' ]  
} as const;

const schemaTyped = toTypedRxJsonSchema(F_COLLABORATEUR_SCHEMA_LITERAL);
export type RxFCollaborateurDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_COLLABORATEUR_SCHEMA: RxJsonSchema<RxFCollaborateurDocumentType> = F_COLLABORATEUR_SCHEMA_LITERAL;
